/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IGetActiveMenusResponse, IHospitalityMenuItem, IHospitalityMenuLevel } from '../custom-actions/DataServiceEntities.g';

const isOffered = (entry: IHospitalityMenuItem | undefined): boolean => !entry?.IsExcludedFromECOM;

/** A copy of the same class as the original, so that MobX keeps it by reference instead of converting it as a plain object. */
const sameClassCopy = <T extends object, C extends object>(original: T, changes: C): T & C =>
    Object.assign(Object.create(Object.getPrototypeOf(original)) as T, original, changes);

const offeredLevel = <T extends IHospitalityMenuLevel>(level: T): T =>
    sameClassCopy(level, {
        Items: level.Items?.filter(isOffered),
        SubLevels: level.SubLevels?.filter(isOffered).map(offeredLevel)
    });

/** The menus with every menu, level and item excluded from ecommerce left out; the response given is not changed. */
export const withoutExcludedFromEcom = (response: IGetActiveMenusResponse): IGetActiveMenusResponse =>
    response.Menus ? sameClassCopy(response, { Menus: response.Menus.filter(isOffered).map(offeredLevel) }) : response;
